module.exports = __webpack_public_path__ + "static/exavalu-slider-6f0d0870023b1dd4d2526bc94e07cdf0.png";